export { default } from "./BodyBold";
